import * as React from 'react';
import { Input, Button, Space, Dropdown } from 'antd';
import {
    SearchOutlined,
    DeleteOutlined,
    InboxOutlined,
    FlagOutlined,
    FolderOutlined,
    TagOutlined,
    UndoOutlined,
    RedoOutlined,
    PrinterOutlined,
    ReloadOutlined,
    MoreOutlined,
    EditOutlined,
    CalendarOutlined,
    BellOutlined,
    SettingOutlined,
    MenuOutlined,
} from '@ant-design/icons';
import './MailToolbar.scss';

const { Search } = Input;

interface MailToolbarProps {
    onSearch: (query: string) => void;
}

const MailToolbar: React.FC<MailToolbarProps> = ({ onSearch }) => {
    const [searchValue, setSearchValue] = React.useState('');

    const handleSearch = (value: string) => {
        setSearchValue(value);
        onSearch(value);
    };

    const actionMenuItems = [
        {
            key: 'move',
            label: 'Move',
            icon: <FolderOutlined />,
        },
        {
            key: 'categorize',
            label: 'Categorize',
            icon: <TagOutlined />,
        },
    ];

    return (
        <div className="mail-toolbar">
            <div className="mail-toolbar-left">
                <Button type="text" icon={<MenuOutlined />} className="menu-button" />
                <div className="mail-toolbar-menu">
                    <Button type="text">File</Button>
                    <Button type="text">Home</Button>
                    <Button type="text">View</Button>
                </div>
            </div>
            <div className="mail-toolbar-center">
                <Search
                    placeholder="Search email..."
                    prefix={<SearchOutlined />}
                    allowClear
                    onSearch={handleSearch}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{ width: '100%', maxWidth: 600 }}
                />
            </div>
            <div className="mail-toolbar-right">
                <Space>
                    <Button type="text" icon={<CalendarOutlined />} title="Calendar" />
                    <Button type="text" icon={<BellOutlined />} title="Notifications" />
                    <Button type="text" icon={<SettingOutlined />} title="Settings" />
                    <Button type="text" icon={<MoreOutlined />} />
                </Space>
            </div>
            <div className="mail-toolbar-actions">
                <Button type="primary" className="mail-context-button">
                    Mail <span style={{ marginLeft: 4 }}>▼</span>
                </Button>
                <Space>
                    <Button type="text" icon={<DeleteOutlined />} title="Delete" />
                    <Button type="text" icon={<InboxOutlined />} title="Archive" />
                    <Button type="text" icon={<DeleteOutlined />} title="Junk" />
                    <Button type="text" icon={<FlagOutlined />} title="Flag" />
                    <Button type="text" icon={<FolderOutlined />} title="Move" />
                    <Button type="text" icon={<TagOutlined />} title="Categorize" />
                    <Button type="text" icon={<UndoOutlined />} title="Undo" />
                    <Button type="text" icon={<RedoOutlined />} title="Redo" />
                    <Button type="text" icon={<PrinterOutlined />} title="Print" />
                    <Button type="text" icon={<ReloadOutlined />} title="Refresh" />
                    <Dropdown
                        menu={{ items: actionMenuItems }}
                        trigger={['click']}
                        placement="bottomRight"
                    >
                        <Button type="text" icon={<MoreOutlined />} />
                    </Dropdown>
                </Space>
            </div>
            <div className="mail-toolbar-compose">
                <Button type="primary" icon={<EditOutlined />} className="compose-button">
                    Compose Mail
                </Button>
            </div>
        </div>
    );
};

export default MailToolbar;
